export enum SiteId {
  HOLIDAYS = 'holidays',
  HOTELS = 'hotels',
  SELF_SERVICE = 'self-service',
}
